function FlashingLight() {
  return (
    <div className="bg-primary-purple rounded-full w-3 h-3 animate-pulse"></div>
  );
}

export default FlashingLight;
